import { TemplatesTable } from "components";

const Templates = () => {



    return (
        <TemplatesTable/>
    );

}
export default Templates;